import type { Connector } from '@prisma/client'
import { useRouteLoaderData } from 'react-router'
import type { WorkspaceSlugLoaderType } from '#app/routes/workspaces+/$slug.js'

type WorkspaceSlugRouteLoaderData = ReturnType<
	typeof useRouteLoaderData<WorkspaceSlugLoaderType>
>
type CurrentWorkspaceFromLoader =
	NonNullable<WorkspaceSlugRouteLoaderData>['currentWorkspace']

export function useCurrentWorkspace() {
	const data = useRouteLoaderData<WorkspaceSlugLoaderType>(
		'routes/workspaces+/$slug',
	)

	// make primary connector easy to access
	const workspace = {
		...data?.currentWorkspace,
		primaryConnector: data?.currentWorkspace?.connectors.sort(
			(a, b) =>
				(a.configConnectorOrder[0]?.order || 0) -
				(b.configConnectorOrder[0]?.order || 0),
		)[0],
	}

	return workspace as CurrentWorkspaceFromLoader & {
		primaryConnector: Connector | undefined
	}
}
